import ButtonBase from '@ixigo/iui/ButtonBase';
import cn from '@repo/shared/utils/cn';
import { CabCard, type CabCardProps } from './CabCard';
import type { CabSelectionOptions } from './index.types';

export interface CabPickerProps {
	cabSelectionOptions: CabSelectionOptions;
	selectedCabId?: string;
	onChange: (cabId: string) => void;
	burnOpted?: CabCardProps['burnOpted'];
}

export function CabPicker({
	cabSelectionOptions,
	selectedCabId,
	onChange,
	burnOpted,
}: CabPickerProps) {
	const { options: cabOptions, imageMap } = cabSelectionOptions;

	const handleCabSelect = (cabId: string) => {
		onChange(cabId);
	};

	return (
		<div className="flex-1 p-20 space-y-4">
			{cabOptions.map((cab) => {
				const isSelected = cab.cabId === selectedCabId;
				return (
					<ButtonBase
						onClick={() => handleCabSelect(cab.cabId)}
						className={cn(
							'cursor-pointer w-full rounded-[15px] transition-transform duration-300 ease-in-out',
							isSelected ? 'scale-105' : 'scale-100',
						)}
						key={cab.cabId}
					>
						<CabCard
							{...cab}
							isSelected={isSelected}
							// TODO: remove this once @naveen normalizes the vehicle type
							iconUrl={imageMap[cab.vehicleType.toUpperCase()] || ''}
							burnOpted={burnOpted}
						/>
					</ButtonBase>
				);
			})}
		</div>
	);
}

export default CabPicker;
